import React from "react";
import { Grid, Typography, makeStyles } from "@material-ui/core";
import AuthorizedVouchersTable from "../components/AuthorizedVouchersTable";
import DashboardStatCard from "../components/DashboardStatCard";
import SelectorMesAnio from "../components/SelectorMesAnio";
import useContableDashboard from "../hooks/useContableDashboard";

const useStyles = makeStyles((theme) => ({
  root: {
    minHeight: "calc(100vh - 96px)",
    background: "#080f1f",
    padding: theme.spacing(3),
  },
  grid: {
    width: "100%",
    margin: 0,
  },
  statusText: {
    color: "#b8cdf0",
    fontSize: 13,
    marginBottom: theme.spacing(2),
  },
  errorText: {
    color: "#ff8a9a",
    fontSize: 13,
    marginBottom: theme.spacing(2),
  },
}));

const DashboardView = () => {
  const classes = useStyles();
  const {
    authorizedVouchers,
    error,
    loading,
    stats,
    page,
    rowsPerPage,
    onPageChange,
    onRowsPerPageChange,
    mes,
    anio,
    onMesChange,
    onAnioChange,
  } = useContableDashboard({ useMonthFilter: true });

  return (
    <div className={classes.root}>
      <SelectorMesAnio
        mes={mes}
        anio={anio}
        onMesChange={onMesChange}
        onAnioChange={onAnioChange}
      />
      {loading && (
        <Typography className={classes.statusText}>
          Cargando informacion contable...
        </Typography>
      )}
      {error && <Typography className={classes.errorText}>{error}</Typography>}
      <Grid container spacing={2} className={classes.grid}>
        {stats.map((item, index) => (
          <Grid
            item
            xs={12}
            sm={index < 3 ? 4 : 6}
            md={index < 3 ? 4 : 3}
            key={item.title}
          >
            <DashboardStatCard item={item} />
          </Grid>
        ))}
      </Grid>
      <AuthorizedVouchersTable
        error={authorizedVouchers.error}
        loading={authorizedVouchers.loading}
        rows={authorizedVouchers.comprobantes}
        totalElements={authorizedVouchers.totalElements}
        page={page}
        rowsPerPage={rowsPerPage}
        onPageChange={onPageChange}
        onRowsPerPageChange={onRowsPerPageChange}
      />
    </div>
  );
};

export default DashboardView;
